import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5001',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Keys the login page reads after a session ends: why, and where to go back to.
export const SESSION_EXPIRED_KEY = 'ipri:session-expired';
export const RETURN_TO_KEY = 'ipri:return-to';

// A 401 on a signed-in request means the session is over (token expired, account deactivated,
// or the secret rotated). Clear the cached identity as well as the token, remember where the
// person was, and send them to sign in. Sign-in and MFA calls answer 401 for a wrong password or
// code, which is not a session problem, so they are left alone.
const PRE_AUTH = ['/api/auth/login', '/api/mfa/verify'];
API.interceptors.response.use(
  (response) => response,
  (error) => {
    const url: string = error.config?.url || '';
    if (error.response?.status === 401 && !PRE_AUTH.some((p) => url.includes(p)) && localStorage.getItem('token')) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      try {
        sessionStorage.setItem(SESSION_EXPIRED_KEY, '1');
        const here = window.location.pathname + window.location.search;
        if (here !== '/login') sessionStorage.setItem(RETURN_TO_KEY, here);
      } catch { /* storage unavailable */ }
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default API;
